import { useAppBar } from "@/appBar/useAppBar";
import ReportsIllustration from "@/assets/img/reports.svg";
import ReportsIllustrationDark from "@/assets/img/reportsDark.svg";
import { VBox } from "@/components-v2/Box";
import { Button } from "@/components-v2/Button";
import { EmptyState } from "@/components-v2/EmptyState";
import { FullScreenLayout } from "@/components-v2/FullScreenLayout";
import { navigateTo } from "@/events/eventsDomain";
import { useMessageStore } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";
import { usePortfolio } from "../portfolioDomain";

export const ReportsPage = observer(() => {
  const alertStore = useMessageStore();
  const { portfolio, header } = usePortfolio({ portfolioType: "all-companies" });
  const appBar = useAppBar({
    isPortfolioPage: true,
    portfolioHeader: header,
    selectedPortfolioOption: portfolio,
  });

  return (
    <FullScreenLayout
      bg
      appBar={appBar}
      disableAppBarShadow
      disableAppBarBorder
      alertStore={alertStore}
      centerPanel={
        <VBox grow={"golden"} justifyContent={"center"}>
          <EmptyState
            illustration={
              <>
                <img
                  src={ReportsIllustration}
                  alt={"Reports illustration"}
                  className="hide-on-dark"
                />
                <img
                  src={ReportsIllustrationDark}
                  alt={"Reports illustration"}
                  className="show-on-dark"
                />
              </>
            }
            title={{ key: "portfolio.reports.empty-state.title" }}
            actions={
              <Button
                variant={"primary"}
                label={{ key: "portfolio.reports.empty-state.action" }}
                onClick={[navigateTo({ name: "portfolio/reports/result" })]}
              />
            }
          />
        </VBox>
      }
    />
  );
});
